// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 86 ? "7069e3e8" : chunkId) + "." + {"86":"6949a1a3e5de36b5","139":"e0b8da9815ba2cf2","675":"4ecd28405b07d3a4","733":"6dbfb4642fa86b34"}[chunkId] + ".js";
};